import {takeEvery} from 'redux-saga/effects'
import {
  DELETE_COLLEGE_COUNSELLING_DOCUMENT,
  DELETE_COLLEGE_COUNSELLING_PORTFOLIO,
  DOWNLOAD_COLLEGE_COUNSELLING_APPLICATION_PDF,
  DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION,
  DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION_WORD,
  GET_COLLEGE_COUNSELLING_DOCUMENT_TYPES,
  GET_COLLEGE_COUNSELLING_PORTFOLIO,
  GET_COLLEGE_COUNSELLING_PORTFOLIOS,
  GET_COLLEGE_COUNSELLING_PORTFOLIO_STATS,
  GET_COLLEGE_COUNSELLING_TEACHERS,
  GET_COLLEGE_COUNSELLING_TEACHER_REQUESTS,
  GET_EXTERNAL_RECOMMENDATION_REQUEST,
  GET_MY_COLLEGE_COUNSELLING_PORTFOLIO,
  GET_MY_COLLEGE_COUNSELLING_PORTFOLIOS,
  REJECT_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST,
  RETURN_COLLEGE_COUNSELLING_PORTFOLIO,
  SAVE_COLLEGE_COUNSELLING_ACADEMICS,
  SAVE_COLLEGE_COUNSELLING_DESTINATIONS,
  SAVE_COLLEGE_COUNSELLING_DOCUMENT,
  SAVE_COLLEGE_COUNSELLING_RECOMMENDATION_DRAFT,
  SAVE_COLLEGE_COUNSELLING_SECTION,
  SEND_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST,
  SET_COLLEGE_COUNSELLING_PORTFOLIO_STATUS,
  START_COLLEGE_COUNSELLING_APPLICATION,
  SUBMIT_COLLEGE_COUNSELLING_PORTFOLIO,
  SUBMIT_COLLEGE_COUNSELLING_RECOMMENDATION,
  SUBMIT_EXTERNAL_RECOMMENDATION,
} from 'setup/redux/Actions/CollegeCounsellingPortfolio/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* collegeCounsellingPortfolioSaga() {
  yield takeEvery(DELETE_COLLEGE_COUNSELLING_DOCUMENT, fetchData)
  yield takeEvery(DOWNLOAD_COLLEGE_COUNSELLING_APPLICATION_PDF, fetchData)
  yield takeEvery(DELETE_COLLEGE_COUNSELLING_PORTFOLIO, fetchData)
  yield takeEvery(DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION, fetchData)
  yield takeEvery(DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION_WORD, fetchData)
  yield takeEvery(GET_COLLEGE_COUNSELLING_DOCUMENT_TYPES, fetchData)
  yield takeEvery(GET_COLLEGE_COUNSELLING_PORTFOLIO, fetchData)
  yield takeEvery(GET_COLLEGE_COUNSELLING_PORTFOLIOS, fetchData)
  yield takeEvery(GET_COLLEGE_COUNSELLING_PORTFOLIO_STATS, fetchData)
  yield takeEvery(GET_COLLEGE_COUNSELLING_TEACHERS, fetchData)
  yield takeEvery(GET_COLLEGE_COUNSELLING_TEACHER_REQUESTS, fetchData)
  yield takeEvery(GET_EXTERNAL_RECOMMENDATION_REQUEST, fetchData)
  yield takeEvery(GET_MY_COLLEGE_COUNSELLING_PORTFOLIO, fetchData)
  yield takeEvery(GET_MY_COLLEGE_COUNSELLING_PORTFOLIOS, fetchData)
  yield takeEvery(REJECT_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST, fetchData)
  yield takeEvery(RETURN_COLLEGE_COUNSELLING_PORTFOLIO, fetchData)
  yield takeEvery(SET_COLLEGE_COUNSELLING_PORTFOLIO_STATUS, fetchData)
  yield takeEvery(SAVE_COLLEGE_COUNSELLING_ACADEMICS, fetchData)
  yield takeEvery(SAVE_COLLEGE_COUNSELLING_DESTINATIONS, fetchData)
  yield takeEvery(SAVE_COLLEGE_COUNSELLING_DOCUMENT, fetchData)
  yield takeEvery(SAVE_COLLEGE_COUNSELLING_RECOMMENDATION_DRAFT, fetchData)
  yield takeEvery(SAVE_COLLEGE_COUNSELLING_SECTION, fetchData)
  yield takeEvery(SEND_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST, fetchData)
  yield takeEvery(START_COLLEGE_COUNSELLING_APPLICATION, fetchData)
  yield takeEvery(SUBMIT_COLLEGE_COUNSELLING_PORTFOLIO, fetchData)
  yield takeEvery(SUBMIT_COLLEGE_COUNSELLING_RECOMMENDATION, fetchData)
  yield takeEvery(SUBMIT_EXTERNAL_RECOMMENDATION, fetchData)
}

export default collegeCounsellingPortfolioSaga
